import http from './http';

export default {
  all() {
    return http().get(`/v1/campaign_costs`);
  },
  get(id) {
    return http().get(`/v1/campaign_costs/${id}`);
  },
  create(data) {
    return http().post(`/v1/campaign_costs`, data);
  },
  update(data) {
    return http().put(`/v1/campaign_costs/${data.id}`, data);
  },
  delete(id) {
    return http().delete(`/v1/campaign_costs/${id}`);
  },
}
